export default "__VITE_ASSET__b8b5451a__"